module.exports = __webpack_public_path__ + "static/img/305.10db03ef.png";